<span [class]="classes">{{ status() | formatCamelCase }}</span>
